import React from 'react';
import styled from '@emotion/styled';

interface Props {
  width: number;
  height: number;
  children: any;
}

const Container = styled.div<{
  width: number;
  height: number;
}>`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  align-self: flex-start;
  overflow: hidden;
`;

const RecaptchaWrapper: React.FC<Props> = ({ width, height, children }) => {
  return (
    <Container width={width} height={height}>
      {children}
    </Container>
  );
};

export default React.memo(RecaptchaWrapper);
